<!-- TODO: switch router usage once upgraded from vue-router 3 to 4 -->
<template>
  <div v-if="!isLoading" class="wrapper">
    <div class="container">
      <button class="btn btn-default-back" @click="$router.back()" type="button">Back</button>
      <h1 class="cms-cancellation-policy-title" v-html="cms.asText(policy[0].title)"></h1>
      <hr class="hr-magazine hr-magazine-left hr-magazine-thick hr-magazine-short" />
      <div class="cms-cancellation-policy" v-html="cms.asHtml(policy[0].policy)"></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue";
import cms from "../services/cms/cms";
import { CmsDocumentTypes, CmsSubscriptionPolicyData } from "../services/cms/cms-type-definitions";

const policy = ref<CmsSubscriptionPolicyData[]>([]);
const isLoading = ref(true);

const cmsService = cms;

const fetchData = async () => {
  cmsService.getAll(CmsDocumentTypes.CmsSubscriptionPolicy).then((resp: any[]) => {
    policy.value = resp.map((e) => e.data);
    isLoading.value = false;
  });
};

onMounted(() => {
  fetchData();
});
</script>

<style lang="less">
@import (reference) "../styles/bootstrap/variables.less";

// These selectors cannot be calculated in scoped css because the CMS HTML
// isn't available until after the scoped CSS is calculated. Hope that makes sense!
.cms-cancellation-policy-title {
  h1 {
    @media (max-width: 450px) {
      font-size: 2.6rem;
    }
  }
}

.cms-cancellation-policy {
  h2 strong {
    color: #333333;
    @media (max-width: 450px) {
      font-size: 2rem;
    }
  }
}
</style>

<style lang="less" scoped>
@import (reference) "../styles/bootstrap/variables.less";

.wrapper {
  padding-top: 1rem;
  width: 100%;
  min-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  .container {
    width: 60%;

    h1 {
      @media (max-width: 450px) {
        font-size: 2.6rem;
      }
    }

    @media (max-width: 900px) {
      width: 80%;
      margin-top: 4rem;
    }
    @media (max-width: 600px) {
      margin-top: 5rem;
      width: 80%;
    }

    .btn {
      position: absolute;
      margin-left: -130px;
      margin-top: 22px;
      @media (max-width: 900px) {
        position: unset;
        margin-left: 0;
        margin-top: 0;
      }
    }
  }
}
</style>
